import imgSrc from "../assets/images/dragon_char.png";
import styled from "styled-components";

const Wrapper = styled.div`
    width: 70%;
`;

const ImageContainer = styled.div`
    width: 100%;
    text-align: center;
`;

const AboutUs = props => {
    return (
        <div className="about-description">
            <Wrapper>
                <ImageContainer>
                    <img className="dragon-char" src={imgSrc} alt="xiao-loong" />
                </ImageContainer>
            <p>
                Welcome to Xiao Loong Restaurant, Cuisine of Northern China. We
                strive to bring our guests a culinary experience of traditional
                cooking by families in China. Many dishes and cooking techniques
                stem from recipes passed on from generation to generation and
                have a history originating in Northern and Central China.
            </p>
            <p>
                The regions of Sichuan and Beijing are the heart of Xiao Loong's
                cuisine and can be recognized by the different uses of
                aromatics, spices, and cooking styles. Dishes prepared in the
                Sichuan and Beijing style are characterized by spicy and pungent
                flavors, with an emphasis on strong flavored roots and
                vegetables such as peppers, garlic, and ginger as well as a
                prolific amount of chilis and spicy sauces. You will find
                traditional fare including Kung Pao Chicken, Mongolian Beef, and
                Potstickers, but you will also find innovative items like Prawns
                with Chinese Chive Dumplings, Spicy Chili Prawns, and Xiao Loong
                Beef.
            </p>
            </Wrapper>
        </div>
    );
};

export default AboutUs;
